import { createFileRoute, redirect } from "@tanstack/react-router";
import { getOrgAssetScopedRecordWorkspacePath } from "@/features/assets/lib/get-org-asset-workspace-path.util";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/assets/(asset)/$assetId/workspace/records/$recordId/workspace/",
)({
	beforeLoad: ({ params }) => {
		throw redirect({
			href: getOrgAssetScopedRecordWorkspacePath({
				orgId: params.orgId,
				assetId: params.assetId,
				recordId: params.recordId,
				tab: "form",
			}),
		});
	},
});
